import React, { useState } from 'react'
import API_URL from './ApiUrl'
import { useTranslation } from 'react-i18next';

const EmailForm = ({ token, setFormDone }) => {
    
      const { t } = useTranslation();
    const [apiresponse, setApiResponse] = useState({
        loading: false,
        success: false,
        status: '',
        error: false
    });
    const [formInput, setFormInput] = useState({
        account: "",
    });
    const [formError, setFormError] = useState({
        account: "",
        response: "",
    });

    const handleUserInput = (name, value) => {
        setFormInput({
            ...formInput,
            [name]: value,
        })
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        let inputError = {
            account: "",
            response: "",
        }

        let inputRespone = {
            loading: false,
            success: false,
            status: '',
            error: false
        }
        setApiResponse({
            ...inputRespone
        });
        if (!formInput.account) {
            setFormError({
              ...inputError,
              account: t("delete_form.error.input.account_empty"),
            });
            return;
        }
        if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formInput.account)) {
            setFormError({
              ...inputError,
              account: t("delete_form.error.input.format"),
            });
            return;
        }
        /* if (!/(?!.*(.)\1{4})^(?!.*(12345|23456|34567|45678|56789).*).{9,}$/.test(formInput.account)) {
            setFormError({
                ...inputError,
                account: "不可有數字或英文字母連續 5 碼相同或連續",
            })
            return;
        } */

        setFormError(inputError);

        setApiResponse({
            ...apiresponse,
            loading: true
        });
        await fetch(`${API_URL}/users/request-deletion`, {
            body: JSON.stringify({
                email: formInput.account,
            }),
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(function (response) {
                console.log(response);
                setApiResponse({
                    loading: false,
                    success: response.ok,
                    status: response.status,
                    error: response.status !== 200 ? true : false
                });
                if (response.ok) {
                    console.log(response.ok);
                    setFormDone(true);
                } else {
                    switch (response.status) {
                        case 404:
                            setFormError({
                                ...inputError,
                                response: t('delete_form.error.result.user_not_found')
                            })
                            break;
                        case 502:
                            setFormError({
                                ...inputError,
                                response: t('delete_form.error.result.send_fail')
                            })
                            break;

                        default:
                            setFormError({
                                ...inputError,
                                response: t('delete_form.error.result.other') + response.status
                            })
                            break;
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                setApiResponse({
                    error: true,
                    loading: false,
                    status: error
                });
            });

    }

    return (
        <form onSubmit={handleSubmit} className='form'>
            <p className="label">{t('delete_form.title')}</p>
            <input name="account"
                type="account"
                onChange={({ target }) => handleUserInput(target.name, target.value)}
                value={formInput.account}
                placeholder={t('delete_form.input.placeholder')}
            />
            <p className="error-message">{formError.account}</p>

            {apiresponse.success && <p className="success-message">{t('delete_form.result')}</p>}
            <p className="error-message">{formError.response}</p>
            {/* {apiresponse.error && <p className="error-message">錯誤{apiresponse.status}</p>} */}
            <input className='submit' type="submit" value={t('delete_form.btn')} disabled={apiresponse.loading || apiresponse.success} />
        </form>
    )
}

export default EmailForm;